import { createStore } from 'vuex';

import auth from './auth';
import users from './users';
import labels from './labels';
import barcodes from './barcodes';
import locations from './locations';


export default createStore({
  modules: {
    auth,
    users,
    labels,
    barcodes,
    locations,
  }
});